import { graphql } from '~/lib/graphql'

export const PlanDetailChildMenuFragment = graphql(`
  fragment PlanDetailChildMenuItem on ChildMenu {
    childMenuId
    name
    price
    closeDays
    visitingPeriodFrom
    visitingPeriodTo
    image {
      url
      name
      category
    }
    description
    __typename
  }
`)
